// extracted by mini-css-extract-plugin
export default {"form":"StmDashboard_form__lUQmj","loader":"StmDashboard_loader__WREkC"};